import Page from "webPage/Page";
import TestimonialModal from "modal/TestimonialModal.js";
import ProductCardModal from "modal/ProductCardModal.js";

Page.register('page-template-tpl-product', () => {
    $('body').on('click', '.js-read-testimonial', function(){
        let clone = $(this).closest('.js-product-card').clone();
        let modal = new TestimonialModal(clone);
        modal.show();

        return false;
    }).on('click', '.js-product-card-modal-toggle', function(){
        let clone = $(this).closest('.js-product-card-logo').clone();
        let modal = new ProductCardModal(clone);
        modal.show();

        return false;
    });
});
